import { Icon } from '@design/components/icon/Icon';
import { Tooltip, TooltipTrigger } from '@design/components/tooltip/Tooltip';
import { enUS } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

import { getFormattedDates } from '../../utils/utils';
import styles from './DateCell.module.scss';

export interface DateCellProps {
  date: Date;
  displayIcon?: boolean;
}

export const DateCell = ({ date, displayIcon = true }: DateCellProps) => {
  const { isBeforeNineThirtyAm, isAfterFourPm, formattedDate } =
    getFormattedDates(date);

  return (
    <span className={styles.dateContainer} data-date-container>
      {formattedDate}
      {displayIcon && (
        <Tooltip
          isTouchDevice={false}
          trigger={TooltipTrigger.Hover}
          label={
            <span className={styles.timeLabel}>
              {formatInTimeZone(date, 'America/New_York', 'h:mmaaa zz', {
                locale: enUS,
              })}
            </span>
          }
        >
          <span className={styles.iconWrapper}>
            {isBeforeNineThirtyAm && (
              <Icon iconName="SunRise" size={16} className={styles.sunRise} />
            )}
            {isAfterFourPm && (
              <Icon iconName="Moon" size={16} className={styles.moon} />
            )}
            {!isBeforeNineThirtyAm && !isAfterFourPm && (
              <Icon iconName="Sun" size={16} className={styles.sun} />
            )}
          </span>
        </Tooltip>
      )}
    </span>
  );
};
